import React from 'react';
import Backdrop from '../Backdrop/Backdrop'
import styles from './Popup.module.css';
import handshake from '../../images/Popup/handshake.svg';
import cross from '../../images/Popup/Cross.svg';

const popup = (props) => (
    <div>
        <Backdrop show={props.show} switch={props.switch} />
        <div className={styles.popup}>
            <div className={styles.cross}>
                <img src={cross} alt="" onClick={props.switch}></img>
            </div>
            <div className={styles.shake}>
                <img src={handshake} alt="" />
            </div>
            <div className={styles.thanking}>
                <h1>Congratulations !</h1>
                <div className={styles.innerbox}>
                    <p>{props.message}</p>
                </div>
            </div>
        </div>
    </div>
)

export default popup;